/* Mamir theme – vanilla JS, no dependencies */
(function () {
  'use strict';

  var theme = window.theme || {};

  /* ---------- Helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    if (!format || !placeholder.test(format)) format = '₪{{amount}}';
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  theme.formatMoney = formatMoney;

  // Build a money format from a sample rendered by Liquid in the visitor's
  // currency (e.g. "₪1,234.56"), so JS prices match the active market.
  (function deriveMoneyFormat() {
    var sample = theme.moneySample;
    if (!sample) return;
    var key = null;
    if (sample.indexOf('1,234.56') > -1) key = ['1,234.56', 'amount'];
    else if (sample.indexOf('1.234,56') > -1) key = ['1.234,56', 'amount_with_comma_separator'];
    else if (sample.indexOf("1'234.56") > -1) key = ["1'234.56", 'amount_with_apostrophe_separator'];
    else if (sample.indexOf('1,235') > -1) key = ['1,235', 'amount_no_decimals'];
    else if (sample.indexOf('1.235') > -1) key = ['1.235', 'amount_no_decimals_with_comma_separator'];
    if (key) theme.moneyFormat = sample.replace(key[0], '{{' + key[1] + '}}');
  })();

  function lockScroll(lock) { document.body.classList.toggle('overflow-hidden', lock); }

  /* ---------- Drawers ---------- */
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    lockScroll(false);
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) { e.preventDefault(); openDrawer(target); }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Search toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (!t) return;
    var bar = $('[data-search-bar]');
    if (!bar) return;
    e.preventDefault();
    bar.classList.toggle('is-open');
    if (bar.classList.contains('is-open')) { var i = bar.querySelector('input'); if (i) i.focus(); }
  });

  /* ---------- Announcement rotation ---------- */
  function initAnnouncements() {
    $$('[data-announcement]').forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4000;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Countdown (evergreen – resets daily at midnight or fixed date) ---------- */
  function initCountdowns() {
    $$('[data-countdown]').forEach(function (el) {
      var end = el.getAttribute('data-end');
      var target;
      function computeTarget() {
        if (end) {
          var d = new Date(end);
          if (!isNaN(d) && d > new Date()) return d;
        }
        var t = new Date();
        t.setHours(23, 59, 59, 999);
        return t;
      }
      target = computeTarget();
      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function tick() {
        var diff = target - new Date();
        if (diff <= 0) { target = computeTarget(); diff = target - new Date(); }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var hEl = el.querySelector('[data-h]'), mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Live viewers (social proof) ---------- */
  function initViewers() {
    $$('[data-viewers]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 8;
      var max = parseInt(el.getAttribute('data-max'), 10) || 30;
      var tpl = el.getAttribute('data-template');
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      function render() { el.textContent = tpl.replace('[count]', n); }
      render();
      setInterval(function () {
        n = Math.min(max, Math.max(min, n + Math.floor(Math.random() * 5) - 2));
        render();
      }, 6000);
    });
  }

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    val = btn.getAttribute('data-qty-btn') === 'plus' ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  var Cart = {
    sectionId: 'cart-drawer',
    drawer: function () { return document.getElementById('CartDrawer'); },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count > 0 ? count : ''; });
    },

    renderSection: function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    },

    refresh: function () {
      return fetch(theme.routes.root_url.replace(/\/$/, '') + '/?sections=' + Cart.sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) { Cart.renderSection(data[Cart.sectionId]); })
        .then(function () { return fetch(theme.routes.cart_url + '.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.updateCount(cart.item_count); return cart; });
    },

    add: function (formData) {
      formData.append('sections', Cart.sectionId);
      formData.append('sections_url', window.location.pathname);
      return fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message || theme.strings.error);
          if (res.sections) Cart.renderSection(res.sections[Cart.sectionId]);
          return fetch(theme.routes.cart_url + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { Cart.updateCount(cart.item_count); return cart; });
    },

    change: function (line, quantity) {
      var inner = $('[data-cart-drawer-inner]');
      if (inner) inner.classList.add('is-loading');
      return fetch(theme.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: [Cart.sectionId], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.sections) Cart.renderSection(cart.sections[Cart.sectionId]);
          Cart.updateCount(cart.item_count);
          if (document.body.classList.contains('template-cart')) window.location.reload();
        })
        .finally(function () { var i = $('[data-cart-drawer-inner]'); if (i) i.classList.remove('is-loading'); });
    }
  };
  theme.Cart = Cart;

  // Cart drawer quantity / remove
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line-qty]');
    if (!input) return;
    Cart.change(parseInt(input.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    Cart.change(parseInt(rm.getAttribute('data-line'), 10), 0);
  });

  // Open cart drawer from header icon
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('[data-cart-icon]');
    if (!icon || !Cart.drawer() || document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    openDrawer(Cart.drawer());
  });

  // AJAX product forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || !Cart.drawer() || form.getAttribute('data-ajax') === 'false') return;
    e.preventDefault();
    var buttons = $$('[type="submit"]', form).concat($$('[data-sticky-submit]'));
    var labels = buttons.map(function (b) { return b.innerHTML; });
    buttons.forEach(function (b) { b.disabled = true; b.textContent = theme.strings.adding; });
    var errorEl = form.querySelector('[data-form-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    Cart.add(new FormData(form))
      .then(function () { openDrawer(Cart.drawer()); })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        else alert(err.message);
      })
      .finally(function () {
        buttons.forEach(function (b, i) { b.disabled = false; b.innerHTML = labels[i]; });
      });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('form[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[name="quantity"]');
    var priceEl = root.querySelector('[data-price]');
    var submit = form && form.querySelector('[data-add-to-cart]');
    var stickyBtn = document.querySelector('[data-sticky-submit]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var currentVariant = product.variants.find(function (v) { return v.id === parseInt(idInput && idInput.value, 10); }) || product.variants[0];

    function getSelectedOptions() {
      return $$('[data-option-index]', root).map(function (fs) {
        var checked = fs.querySelector('input:checked');
        var select = fs.querySelector('select');
        return checked ? checked.value : (select ? select.value : null);
      });
    }

    function priceHTML(variant, qty, discount) {
      qty = qty || 1;
      discount = discount || 0;
      var price = Math.round(variant.price * qty * (1 - discount / 100));
      var compare = variant.compare_at_price && variant.compare_at_price > variant.price
        ? variant.compare_at_price * qty
        : (discount > 0 ? variant.price * qty : 0);
      var html = '<span class="price' + (compare ? ' price--sale' : '') + '">';
      html += '<span class="price__current">' + formatMoney(price) + '</span>';
      if (compare) {
        html += '<s class="price__compare">' + formatMoney(compare) + '</s>';
        var pct = Math.round((compare - price) * 100 / compare);
        if (pct > 0) html += '<span class="price__save">-' + pct + '%</span>';
      }
      return html + '</span>';
    }

    function selectedOffer() {
      var o = root.querySelector('[data-offer].is-selected');
      if (!o) return null;
      return { qty: parseInt(o.getAttribute('data-qty'), 10) || 1, discount: parseFloat(o.getAttribute('data-discount')) || 0 };
    }

    function updateOffers(variant) {
      $$('[data-offer]', root).forEach(function (o) {
        var q = parseInt(o.getAttribute('data-qty'), 10) || 1;
        var d = parseFloat(o.getAttribute('data-discount')) || 0;
        var p = o.querySelector('[data-offer-price]');
        if (!p) return;
        var total = Math.round(variant.price * q * (1 - d / 100));
        var full = (variant.compare_at_price > variant.price ? variant.compare_at_price : variant.price) * q;
        p.innerHTML = formatMoney(total) + (full > total ? '<s>' + formatMoney(full) + '</s>' : '');
      });
    }

    function render(variant) {
      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = theme.strings.unavailable; }
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      currentVariant = variant;
      if (idInput) idInput.value = variant.id;
      var offer = selectedOffer();
      if (priceEl) priceEl.innerHTML = priceHTML(variant, offer ? offer.qty : 1, offer ? offer.discount : 0);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(variant);
      updateOffers(variant);
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? submit.getAttribute('data-label') : theme.strings.soldOut;
      }
      if (stickyBtn) stickyBtn.disabled = !variant.available;

      // Update option labels
      $$('[data-option-index]', root).forEach(function (fs, i) {
        var lbl = fs.querySelector('[data-selected-value]');
        if (lbl) lbl.textContent = variant.options[i];
      });

      // Availability styling on option pills
      $$('[data-option-index]', root).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var opts = variant.options.slice();
          opts[idx] = inp.value;
          var match = product.variants.find(function (v) { return v.options.every(function (o, k) { return o === opts[k]; }); });
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      // Jump gallery to variant image
      if (variant.featured_media) {
        var slide = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (slide) goToSlide(root, slide);
      }

      // Update URL
      if (window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) {
        var selected = getSelectedOptions();
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        render(variant);
      }
    });

    // Offers / quantity breaks
    $$('[data-offer]', root).forEach(function (offer) {
      offer.addEventListener('click', function () {
        $$('[data-offer]', root).forEach(function (o) { o.classList.remove('is-selected'); o.querySelector('input').checked = false; });
        offer.classList.add('is-selected');
        offer.querySelector('input').checked = true;
        if (qtyInput) qtyInput.value = offer.getAttribute('data-qty');
        render(currentVariant);
      });
    });

    // Sticky add to cart
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && submit) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', past);
          });
        }).observe(submit);
      }
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else submit.click();
        });
      }
    }

    render(currentVariant);
  }

  /* ---------- Gallery ---------- */
  function goToSlide(root, slide) {
    var track = slide.parentElement;
    var i = Array.prototype.indexOf.call(track.children, slide);
    var rtl = getComputedStyle(track).direction === 'rtl';
    track.scrollTo({ left: (rtl ? -1 : 1) * i * track.clientWidth, behavior: 'smooth' });
    $$('[data-thumb], [data-dot]', root).forEach(function (b) {
      b.classList.toggle('is-active', parseInt(b.getAttribute('data-index'), 10) === i);
    });
  }
  function initGallery(root) {
    var track = root.querySelector('[data-gallery-slides]');
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', root);
    var dots = $$('[data-dot]', root);
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.concat(dots).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-index'), 10);
        goToSlide(root, slides[i]);
        setActive(i);
      });
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
        setActive(Math.min(i, slides.length - 1));
      });
    });
  }

  /* ---------- Collection sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort-by]');
    if (!s) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', s.value);
    window.location.href = url.toString();
  });

  /* ---------- Init ---------- */
  function init(scope) {
    scope = scope || document;
    $$('[data-product]', scope).forEach(function (p) { initProduct(p); initGallery(p); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncements();
    initCountdowns();
    initViewers();
    init();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    initCountdowns();
    initViewers();
  });

  window.theme = theme;
})();
